import { partition, sortBy } from 'remeda';
import { PLATFORM_PARTNER_ID } from 'src/constants/platform';
import type { ConversationAssigneeGroupManagement } from 'src/graphql/entities/conversation-assignee-group';

export function sortPlatformFirstByName(
  groups: ConversationAssigneeGroupManagement[],
): ConversationAssigneeGroupManagement[] {
  const [platform, partner] = partition(
    groups,
    (group) => group.partnerId === PLATFORM_PARTNER_ID,
  );
  const byName = (group: ConversationAssigneeGroupManagement) =>
    (group.name ?? '').toLocaleLowerCase();

  return [...sortBy(platform, byName), ...sortBy(partner, byName)];
}
